module.exports = __webpack_public_path__ + "img/7-request-letters.b9313c6b.webp";